import { defineMessages } from 'react-intl';

export const productVariationMessages = defineMessages({
  slotTitle: {
    id: 'detailview.grid.headline.details',
    defaultMessage: 'Produktdetails und Serviceinfos',
  },
  expandCardText: {
    id: 'collapsibleCard.expand.text',
    defaultMessage: 'Mehr Produkteigenschaften anzeigen',
  },
  collapseCardText: {
    id: 'collapsibleCard.collapse.text',
    defaultMessage: 'Weniger Produkteigenschaften anzeigen',
  },
});
